export default __webpack_public_path__ + "graph-bg.png?ed7bf8c1a1f93dfa52ff28a20c8545b7";